export default "__VITE_ASSET__DwgxkHFi__"